import React from 'react';

import { Row } from 'farmhub-ui-core';

import { CParagraph } from './styles';

type CParagraphProps = {
  disabled?: boolean;
  size?: string;
  weight?: string;
  align?: string;
  textTransform?: string;
  color?: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
  onSubmit: (val: string) => void;
};

const Paragraph = ({
  disabled = false,
  size,
  weight,
  align,
  textTransform,
  color,
  children,
  style,
  onSubmit,
}: CParagraphProps) => {
  const [visible, setIsVisible] = React.useState(false);

  return (
    <CParagraph
      align={align}
      color={color}
      disabled={disabled}
      editable={{
        editing: visible,
        tooltip: false,
        onChange: (e: any) => {
          setIsVisible(false);
          onSubmit(e);
        },
        icon: (
          <Row
            className="action"
            styles={{
              gap: 6,
              flexWWrap: 'nowrap',
              flexShrink: 0,
            }}
            width="fit-content"
          />
        ),
      }}
      size={size}
      style={
        visible ? style : { ...style, width: 'fit-content', minWidth: '64px' }
      }
      textTransform={textTransform}
      visible={visible}
      weight={weight}
      onClick={() => setIsVisible(true)}
    >
      {children}
    </CParagraph>
  );
};

export default Paragraph;
